import React from "react";
import AboutUsComp from "./../components/AboutUs/AboutUs"
const AboutUs = () => {
  return (
    <div>
      <AboutUsComp />
    </div>
  );
};

export default AboutUs;
